module.exports = __webpack_public_path__ + "img/accountant.5349010e.png";